module.exports = __webpack_public_path__ + "static/media/20ECE10.6a14a5a4.jpg";